import React, { SVGProps } from "react";

const SvgRoof7 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 350 300"
    {...props}
  >
    <defs>
      <linearGradient
        id="roof7_svg__b"
        x1={243.958}
        y1={198.605}
        x2={217.03}
        y2={151.965}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.471} stopColor="#b8c9d5" stopOpacity={0} />
        <stop offset={1} stopColor="#b8c9d5" stopOpacity={0.35} />
      </linearGradient>
      <linearGradient
        id="roof7_svg__c"
        x1={63.284}
        y1={222.976}
        x2={90.307}
        y2={176.171}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.316} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="roof7_svg__a"
        x1={328.732}
        y1={113.738}
        x2={328.732}
        y2={87.993}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.117} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof7_svg__d"
        x1={21.399}
        y1={173.635}
        x2={21.399}
        y2={136.219}
        xlinkHref="#roof7_svg__a"
      />
      <linearGradient
        id="roof7_svg__e"
        x1={133.034}
        y1={226.849}
        x2={133.034}
        y2={201.104}
        xlinkHref="#roof7_svg__a"
      />
    </defs>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="url(#roof7_svg__b)"
      d="M132.645 200.81v62.062L328.343 149.76V87.698L132.645 200.81z"
    />
    <path
      fill="url(#roof7_svg__c)"
      d="M132.645 200.879v61.993L21.011 198.57v-62.406l111.634 64.715z"
    />
    <path
      fill="#237aad"
      d="M340 81.333 133.033 201.104l-9.711-126.207 102.714-59.228L340 81.333z"
    />
    <path
      fill="#48d7ff"
      d="M225.854 15.774 123.322 74.897 10 129.78 217.252 10l8.602 5.774z"
    />
    <path
      fill="#05ffff"
      d="M133.033 201.104 10 129.78l113.322-54.883 9.711 126.207z"
    />
    <path fill="url(#roof7_svg__a)" d="M328.232 87.993h1v25.745h-1z" />
    <path fill="url(#roof7_svg__d)" d="M20.899 136.219h1v37.416h-1z" />
    <path fill="url(#roof7_svg__e)" d="M132.534 201.104h1v25.745h-1z" />
    <path
      fill="none"
      stroke="#002839"
      strokeMiterlimit={10}
      d="m123.322 74.897 102.714-59.228"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      d="m133.034 201.105-9.712-126.208L10 129.781"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M133.034 201.105 10 129.781 217.253 10l8.783 5.669L340 81.333 133.034 201.105z"
    />
  </svg>
);

export default SvgRoof7;
